<script setup lang="ts">
interface AccordionProps {
  answers: {
    title: string
    text: string
    iframe?: string
  }[]
  tableName: string
  markdown?: boolean
}
defineProps<AccordionProps>()
</script>

<template>
  <div :data-test="getCypressId(tableName)" flex flex-col gap-16px>
    <FAccordion
      v-for="(item, index) in answers"
      :key="item.title"
      :title="item.title"
      :data-test="getCypressId(`accordion-${index}`)"
    >
      <div flex flex-col gap-16px>
        <template v-if="item.text">
          <StyledMarkdown v-if="markdown" :value="item.text" />
          <p v-else>
            {{ item.text }}
          </p>
        </template>
        <iframe
          v-if="item.iframe"
          fubex-rounded-md
          :src="item.iframe"
          width="100%"
          height="500"
          frameborder="0"
          allowfullscreen
        />
      </div>
    </FAccordion>
  </div>
</template>
